<script setup lang="ts">
import KUICoreInputRichTextEditorRenderer from '~kui/components/KUI/Core/Input/RichTextEditor/Renderer/KUICoreInputRichTextEditorRenderer.vue';

/**
 * The prose-first article body shared by the default blog and editorial essay
 * templates: the rich-text renderer wrapped in the raised-cap treatment.
 */
interface Props {
  content: string;
}

defineProps<Props>();
</script>

<template>
  <div class="article-body">
    <KUICoreInputRichTextEditorRenderer
      :content="content"
      variant="paragraph"
      anchor-headings
      render-blocks
    />
  </div>
</template>

<style scoped>
/* Raised cap, not a floated drop cap: the big letter shares the first
   line's baseline, so the adjacent text aligns with its bottom and a
   short first paragraph can't push later paragraphs into an L-wrap */
.article-body :deep(p:first-of-type:not(blockquote p))::first-letter {
  padding-right: 0.25rem;
  font-size: 3.5em;
  font-weight: 600;
  line-height: 0.75;
}
</style>
